export default __webpack_public_path__ + "static/logo-2f8f30c8207c39bd8dbc73e0c2c10f64.png";